import React from 'react';
import { Globe2, School, GraduationCap } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function MarketSlide(props: SlideProps) {
  return <SlideLayout {...props} title="Market Opportunity" subtitle="The global EdTech market is exploding, with a critical need for automation tools." data-id="element-95">
      <div className="flex flex-col lg:flex-row items-end gap-8 mt-12 justify-center" data-id="element-96">
        {/* TAM */}
        <div className="w-full lg:w-1/3 flex flex-col items-center" data-id="element-97">
          <div className="w-64 h-64 rounded-full bg-slate-100 border-2 border-slate-200 flex flex-col items-center justify-center text-center p-8 mb-6 relative group hover:bg-slate-200 transition-colors" data-id="element-98">
            <Globe2 className="w-12 h-12 text-slate-400 mb-2" data-id="element-99" />
            <div className="text-4xl font-bold text-slate-900" data-id="element-100">$404B</div>
            <div className="text-sm font-bold text-slate-500 uppercase mt-2" data-id="element-101">
              Global EdTech Market
            </div>
            <div className="text-xs text-slate-400 mt-2" data-id="element-102">
              TAM (2025 Projection)
            </div>
          </div>
        </div>

        {/* SAM */}
        <div className="w-full lg:w-1/3 flex flex-col items-center" data-id="element-103">
          <div className="w-56 h-56 rounded-full bg-indigo-50 border-2 border-indigo-100 flex flex-col items-center justify-center text-center p-6 mb-6 relative group hover:bg-indigo-100 transition-colors" data-id="element-104">
            <School className="w-10 h-10 text-indigo-400 mb-2" data-id="element-105" />
            <div className="text-4xl font-bold text-indigo-600" data-id="element-106">$25B</div>
            <div className="text-sm font-bold text-indigo-800 uppercase mt-2" data-id="element-107">
              Assessment Software
            </div>
            <div className="text-xs text-indigo-600/60 mt-2" data-id="element-108">
              SAM (Serviceable Market)
            </div>
          </div>
        </div>

        {/* SOM */}
        <div className="w-full lg:w-1/3 flex flex-col items-center" data-id="element-109">
          <div className="w-48 h-48 rounded-full bg-emerald-500 text-white shadow-xl shadow-emerald-200 flex flex-col items-center justify-center text-center p-4 mb-6 relative hover:scale-105 transition-transform" data-id="element-110">
            <GraduationCap className="w-8 h-8 text-white/80 mb-2" data-id="element-111" />
            <div className="text-4xl font-bold text-white" data-id="element-112">$150M</div>
            <div className="text-sm font-bold text-emerald-100 uppercase mt-2" data-id="element-113">
              Initial Target
            </div>
            <div className="text-xs text-emerald-200 mt-2" data-id="element-114">
              SOM (Universities & Coaching)
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 text-center max-w-2xl mx-auto p-6 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-115">
        <p className="text-slate-600 font-medium" data-id="element-116">
          "Assessment tools are the #1 requested feature by faculty in 2024."
        </p>
        <p className="text-slate-400 text-sm mt-2" data-id="element-117">- EdTech Annual Report</p>
      </div>
    </SlideLayout>;
}